import React from 'react'
import PropTypes from 'prop-types'
import { CSSTransition } from 'react-transition-group'

const ModalTransition = ({ show: showModal, ...props }) => (
  <CSSTransition
    mountOnEnter
    unmountOnExit
    in={showModal}
    timeout={300}
    classNames="modal"
    {...props}
  />
)

ModalTransition.propTypes = {
  show: PropTypes.bool,
}

export default ModalTransition
